import { render } from "./WaitingOverlay.vue?vue&type=template&id=632573b4&scoped=true"
import script from "./WaitingOverlay.vue?vue&type=script&lang=js"
export * from "./WaitingOverlay.vue?vue&type=script&lang=js"

import "./WaitingOverlay.vue?vue&type=style&index=0&id=632573b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632573b4"]])

export default __exports__